export default __webpack_public_path__ + "static/media/Shlimaz.3470c5c0.jpeg";